import React from "react";
import { MarketingReferralTable } from "./MarketingReferralTable";

/* ─────────────────────────────────────────────────────────────
   MarketingReferrals · Phase 4 Homepage (Phase 5 safety-corrected)
   ------------------------------------------------------------
   Uses the marketing-safe presentation table instead of the
   production `ReferralTracking` component — same data shape
   (../../data/marketplaceData) with the "£128.4K MTD" chip and
   Revenue column omitted so unverified fixture figures are NOT
   published as customer performance proof.

   The authenticated marketplace/ReferralTracking primitive is
   untouched.
   ───────────────────────────────────────────────────────────── */

export const MarketingReferrals = () => (
  <section
    id="referrals"
    className="relative"
    style={{ background: "#FAFAFE" }}
    data-testid="landing-referrals"
  >
    <div
      aria-hidden="true"
      className="absolute inset-x-0 top-0 h-px"
      style={{ background: "linear-gradient(90deg, transparent 0%, rgba(15,23,42,0.08) 50%, transparent 100%)" }}
    />
    <div className="max-w-[1440px] mx-auto px-5 sm:px-6 lg:px-10 pt-16 lg:pt-24 pb-16 lg:pb-24">
      {/* Copy block */}
      <div className="max-w-[760px]">
        <p className="text-[10.5px] font-bold uppercase tracking-[0.22em] text-violet-700">
          Referrals
        </p>
        <h2 className="font-display text-[32px] sm:text-[40px] lg:text-[52px] font-bold tracking-[-0.028em] text-slate-900 leading-[1.02] mt-4">
          Referrals without leaving<br />
          <span
            style={{
              background: "linear-gradient(90deg, #4F46E5 0%, #6D28D9 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            the transaction workflow.
          </span>
        </h2>
        <p className="text-[14px] sm:text-[15.5px] text-slate-600 leading-relaxed mt-5 max-w-[560px]">
          Introduce buyers and sellers to the right services — keeping every
          referral connected to the transaction that generated it.
        </p>
      </div>

      {/* Real product surface — ReferralTracking table.
          onClickCapture keeps any accidental interaction on the
          marketing page inert.  A marketing-side edge fade hints
          at the horizontal scroll on narrow viewports. */}
      <div
        className="relative mt-10 lg:mt-14"
        onClickCapture={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        data-testid="landing-referrals-product"
      >
        <MarketingReferralTable />
        {/* Right-edge fade — only visible on mobile where the
            table's inner `overflow-x-auto` scrolls. */}
        <div
          aria-hidden="true"
          className="md:hidden pointer-events-none absolute right-0 top-16 bottom-0 w-10 rounded-r-2xl"
          style={{ background: "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.95) 100%)" }}
        />
      </div>
    </div>
  </section>
);

export default MarketingReferrals;
